import { Framework } from '@/framework/instance';
import { ILayerProps } from '@/version-types';

export class Active extends Framework {
    /** 监听激活图层变化 */
    onChange(fn: (layer: ILayerProps | null, pickLayer: ILayerProps | null) => void, weight = 0) {
        return this.framework.events.onActiveLayerDataUpdate(fn, weight);
    }

    /** 删除激活图层 */
    delete() {
        this.framework.operate.delActiveLayer();
    }

    /** 设置激活图层 */
    set(layerId: string) {
        this.framework.operate.setActiveLayer(layerId);
    }

    /** 获取激活图层 */
    get() {
        return this.framework.operate.getActiveLayer();
    }

    /**
     * 获取激活图层的选中图层
     * 如果 force 为 true，没有选中图层时，会返回激活图层
     * @param force - 默认true
     */
    getPick(force = true) {
        return this.framework.operate.getActivePickLayer(force);
    }

    /** 获取激活画布的所有图层 */
    getLayers() {
        const originIndex = this.framework.stage.getActiveOriginIndex();
        return this.framework.getLayers(originIndex);
    }

    /** 获取激活画布的索引 */
    getActiveStageIndex() {
        return this.framework.stage.getActiveStageIndex();
    }

    /** 获取激活画布的原始索引（等价于 Stage id） */
    getActiveOriginIndex() {
        return this.framework.stage.getActiveOriginIndex();
    }

    /**
     * 监听激活舞台索引变化
     *
     * @param fn - 回调函数
     * @param weight - 可选；权重；默认值为 `0`
     * @returns 监听器
     */
    onStageChange(fn: (args: { stageIndex: number; originIndex: number }) => void, weight = 0) {
        return this.framework.events.onActiveStageChange(fn, weight);
    }

    /**
     * 获取激活画布的背景图层
     *
     * @returns 背景图层
     */
    getBackgroundLayer(index?: number) {
        const originIndex = this.framework.stage.getActiveOriginIndex();
        return this.framework.getBackgroundLayer(index !== undefined ? index : originIndex);
    }

    /** 获取激活画布的主图层 */
    getMainLayer(index?: number) {
        const originIndex = this.framework.stage.getActiveOriginIndex();
        return this.framework.getMainLayer(index !== undefined ? index : originIndex);
    }
}
